import { useEffect } from 'react';
import { JobsComponent, authEvents } from '@umd-dit/jobs-component-react';
import '@umd-dit/jobs-component-react/style.css';
import { useAuth } from "@/context/AuthContext.tsx";

export default function Jobs() {
  const { selectedOrganizationId, selectedWorkspaceId, isAdmin } = useAuth();

  // Subscribe to auth error events from the job component
  useEffect(() => {
    const unsubscribe = authEvents.onAuthError((event) => {
      console.warn('Auth error received in Jobs page:', event);
      // Handle auth errors - could redirect to login or show error message
      if (event.status === 401) {
        console.error('Authentication token invalid or expired');
        // Could trigger token refresh here
      } else if (event.status === 403) {
        console.error('Access forbidden - user may not have required permissions');
      }
    });

    // Clean up the subscription when component unmounts
    return () => {
      unsubscribe();
    };
  }, []);

  return (
    <div className="container mx-auto px-4 py-4">
      <JobsComponent
        appId="legislative-review"
        orgId={selectedOrganizationId || 'demo-org'}
        wsId={selectedWorkspaceId || 'demo-workspace'}
        isAdmin={isAdmin}
      />
    </div>
  );
}